import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { getTickets } from "../../../Actions/HelpAction";
import { useEffect } from "react";
import { setUnreadTickets } from "../../../Actions/UserAction";

const TicketigLink = () => {

    const Dictionary = useSelector(state => state.VisualData.Dictionary);

    const dispatch = useDispatch();

    const hasUnread = useSelector(state => state.UserData?.hasUnreadTicket)

    const localStorageToken = localStorage.getItem("userToken");


    const fetchData = async (token) => {
        const response = await getTickets({
            token: token,
            MaxResultCount: 5,
            SkipCount: 0,
            notRead: true
        });

        if (response?.data?.result?.totalCount) {
            dispatch(setUnreadTickets(!!response.data.result.totalCount))
        } else {
            dispatch(setUnreadTickets(false))
        }
    }


    useEffect(() => {
        let fetchReserveInterval;

        if (localStorageToken) {
            
            fetchData(localStorageToken);

            fetchReserveInterval = setInterval(() => { fetchData(localStorageToken) }, 20000);

        }

        return (() => {
            clearInterval(fetchReserveInterval);
        })

    }, [localStorageToken]);


    return (
        <Link to={"/profile?mode=tickets"} className="link-style-btn margin-start relative">
            <span className="hidden-xsmall">
                {Dictionary.SupportTickets}
            </span>
            <span class="itours-icon gray-chat-icon icon-small3 hidden-small hidden-medium hidden-large" />

            {!!hasUnread && <span className="ticketing-count-badge" />}
        </Link>
    )
}

export default TicketigLink;